import * as actionTypes from "./actionTypes";

import api from "../../services";
import { apiStart, apiSuccess } from "./apiActions";
import { errorHandler, catchHandler, successHandler } from "./responseHandler";
import { getUserData } from "../../utils/localStorage";

export const allblockedPatients = (page = 1) => {
  return dispatch => {
    dispatch(apiStart());
    api
      .blockedPatientList(page, { doctor_id: getUserData()?.id })
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          const resp = res.data[0];
          dispatch({
            type: actionTypes.ALL_BLOCKED_PATIENTS,
            results: resp.results,
            total: resp.links.total_pages,
          });
        } else {
          errorHandler(res.message[0]);
        }

        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const emptyBlockedPatients = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.EMPTY_BLOCKED_PATIENTS,
    });
  };
};

export const patientUnblock = id => {
  return dispatch => {
    dispatch(apiStart());
    api
      .unblockPatient(id)
      .then(response => {
        const res = response.data;
        if (res.status_code === 204) {
          dispatch(allblockedPatients());
          successHandler(res.message[0]);
        } else {
          errorHandler(res.message[0]);
        }

        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const patientBlock = (payload, cb = () => {}) => {
  return dispatch => {
    dispatch(apiStart());
    api
      .blockPatient(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          successHandler(res.message[0]);
          cb();
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const setNudgePermission = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_NUDGE_PERMISSION,
      payload,
    });
};

export const getNudgePermission = () => {
  return dispatch => {
    dispatch(apiStart());
    api
      .getNudgePermission(getUserData().id)
      .then(response => {
        const res = response.data;
        if (res.length > 0) {
          if (res) {
            const detailsObj = res[0];
            dispatch(
              setNudgePermission({
                nudge_permission: detailsObj.nudge_permission,
              })
            );
          } else {
            errorHandler(res.message[0]);
          }
          dispatch(apiSuccess());
        }
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const updateNudgePermission = cb => {
  return (dispatch, getState) => {
    const nudge = getState().settings.nudgePermission;
    const payload = {
      nudge_permission: nudge.nudge_permission,
    };

    dispatch(apiStart());
    api
      .updateNudgePermission(getUserData().id, payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          dispatch(getNudgePermission());
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const getCurrentDoctorDetails = () => {
  return dispatch => {
    dispatch(apiStart());
    api
      .getCurrentPhysician()
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          dispatch({
            type: actionTypes.GET_CURRENT_DOCTOR,
            payload: res.data[0],
          });
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const getCurrentUserLocation = () => {
  return dispatch => {
    dispatch(apiStart());
    api
      .getUserLocation()
      .then(response => {
        const res = response.data;
        if ((response.status_code = 200)) {
          dispatch({
            type: actionTypes.GET_CURRENT_LOCATION,
            payload: res.data[0],
          });
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const changeCurrentLocation = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.CHANGE_CURRENT_LOCATION,
    });
  };
};

export const addUserCurrentLocation = (payload, cb = () => {}) => {
  return dispatch => {
    dispatch(apiStart());
    api
      .addUserLocation(payload)
      .then(response => {
        const res = response.data;
        if (response.status_code === 200) {
          cb();
          successHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const updateUserCurrentLocation = (userId, payload, cb = () => {}) => {
  return dispatch => {
    dispatch(apiStart());
    api
      .updateUserLocation(userId, payload)
      .then(response => {
        if (response.data.status_code === 200) {
          cb();
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const updateDrCurrentLocationStatus = (id, status) => {
  return dispatch => {
    dispatch(apiStart());
    api
      .updateDrLocationStatus(id, { is_current_location: status })
      .then(response => {
        successHandler("Location Updated Successfully");
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const removeCustomerPaymentHistory = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.REMOVE_PAYMENT_HISTORY,
    });
  };
};

export const getCustomerPaymentHistory = () => {
  return (dispatch, getState) => {
    dispatch(apiStart());

    const paymentHistories = getState()?.settings?.paymentHistory?.results;

    const payload =
      {
        starting_after: paymentHistories[paymentHistories?.length - 1]?.id,
      } || null;

    api
      .getCustomerPaymentHistory(getUserData()?.id, payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          dispatch({
            type: actionTypes.GET_PAYMENT_HISTORY,
            payload: {
              results:
                Object.keys(res?.data)?.length > 0
                  ? [...paymentHistories, ...res?.data?.data]
                  : [...paymentHistories],
              hasMore: res?.data?.has_more,
            },
          });
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const downloadInvoice = (invoiceId, cb = () => {}) => {
  return (dispatch, getState) => {
    dispatch(apiStart());

    const payload = {
      invoice_id: invoiceId,
    };

    api
      .downloadInvoice(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          cb(res?.data?.invoice_pdf);
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};
